import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MedicosDominioService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestMedicos(idEmpresa: number, dataInicial: string, dataFinal: string) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/medicos-report?empresaId=${idEmpresa}&dataDe=${dataInicial}&dataPara=${dataFinal}`);

  }
}
